angular.module("ticketco/ticketbuyer/item_types", ["ngDialog"])
.config(['ngDialogProvider', function (ngDialogProvider) {
  ngDialogProvider.setDefaults({
    closeByDocument: true
  });
}]);
